(() => {
  const brandPattern = /\bhibod\b/gi;
  const skippedParents = 'script, style, textarea, template, noscript, [data-hibod-brand-skip]';
  const attributes = ['aria-label', 'title', 'alt', 'placeholder'];
  const observedRoots = new WeakSet();

  const correct = (value) => value ? value.replace(brandPattern, 'hiBOD') : value;

  const correctElementAttributes = (element) => {
    attributes.forEach((attribute) => {
      if (!element.hasAttribute(attribute)) return;
      const current = element.getAttribute(attribute);
      const corrected = correct(current);
      if (corrected !== current) element.setAttribute(attribute, corrected);
    });
  };

  const correctTextNode = (node) => {
    if (!node.parentElement || node.parentElement.closest(skippedParents)) return;
    const corrected = correct(node.nodeValue);
    if (corrected !== node.nodeValue) node.nodeValue = corrected;
  };

  const normalize = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      correctTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    if (root.nodeType === Node.ELEMENT_NODE) correctElementAttributes(root);
    root.querySelectorAll?.('[aria-label], [title], [alt], [placeholder]').forEach(correctElementAttributes);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode;
    while ((textNode = walker.nextNode())) correctTextNode(textNode);

    root.querySelectorAll?.('*').forEach((element) => {
      if (element.shadowRoot) observeRoot(element.shadowRoot);
    });
  };

  const observeRoot = (root) => {
    if (observedRoots.has(root)) return;
    observedRoots.add(root);
    normalize(root);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          correctTextNode(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(normalize);
      });
    }).observe(root, {
      subtree: true,
      childList: true,
      characterData: true
    });
  };

  const start = () => {
    observeRoot(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
